/* eslint-disable max-len */
import { SUBTITLE_BACKGROUND_OPTIONS, SUBTITLE_COLOR_OPTIONS, SUBTITLE_STROKE_OPTIONS } from 'src/interfaces/enums';
import { SUBTITLE_OPACITY_OPTIONS } from 'src/themes/cosmos/containers/SubtitleSettingsOverlay/containers/SubtitleOpacityControl/constants';
import { SUBTITLE_SIZE_OPTIONS } from 'src/themes/cosmos/containers/SubtitleSettingsOverlay/containers/SubtitleSizeControl/constants';
import * as yup from 'yup';

export const schema = yup
  .object()
  .shape({
    color: yup.string().oneOf(Object.values(SUBTITLE_COLOR_OPTIONS)).required(),
    background: yup.string().oneOf(Object.values(SUBTITLE_BACKGROUND_OPTIONS)).required(),
    size: yup.number().oneOf(SUBTITLE_SIZE_OPTIONS).required(),
    stroke: yup.string().oneOf(Object.values(SUBTITLE_STROKE_OPTIONS)).required(),
    opacity: yup.number().oneOf(SUBTITLE_OPACITY_OPTIONS).required(),
  })
  .strict();
